import { type INotificationDTO } from 'dto/NotificationDTO'
import { type INotificationFinancingParams } from 'dto/NotificationDTO/financing'

export const redirectFinancingNotification = (
  notification: INotificationDTO,
) => {
  const { financingId } = notification.params as INotificationFinancingParams

  return `/financiamentos/${financingId}`
}

export const redirectFinancingSimulationNotification = (
  notification: INotificationDTO,
) => {
  const { financingId, simulationId } =
    notification.params as INotificationFinancingParams

  return `/financiamentos/${financingId}/simulacao/${simulationId}`
}
